export async function create({commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$frontendRepositories.groups.create(payload);
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function update({commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$frontendRepositories.groups.update(payload.id, payload);
  commit('setBtnLoading', false, {root: true});
  return response;
}


export async function list() {
  return this.$frontendRepositories.groups.index();
}

export async function tree() {
  return this.$frontendRepositories.groups.tree();
}

export async function inviteUser(_, payload) {
  return this.$frontendRepositories.groups.inviteUser(payload);
}

export async function destroy(_, groupId) {
  return this.$frontendRepositories.groups.delete(groupId);
}

export async function getDetail(_, groupId) {
  return this.$frontendRepositories.groups.show(groupId);
}

export async function getGroupUsers(_, groupId) {
  return this.$frontendRepositories.groups.getGroupUsers(groupId);
}

export async function deleteUser(_, payload) {
  return this.$frontendRepositories.groups.deleteUser(payload);
}

export async function changeRootUser(_, payload) {
  return this.$frontendRepositories.groups.changeRootUser(payload);
}

export async function beforeDelete(_, payload) {
  return this.$frontendRepositories.groups.beforeDelete(payload);
}